var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-heading container"},[_c('div',{staticClass:"inner"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.__('header.quote'))}}),_c('div',{staticClass:"info"},[_vm._v(" "+_vm._s(_vm.__('header.need_a_specialist'))+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.__('header.call_us'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }